module.exports = __webpack_public_path__ + "img/img_saveList.704d51b5.svg";